// extracted by mini-css-extract-plugin
module.exports = {"StarBox":"RatingStars_StarBox__2_cvR","Star":"RatingStars_Star__2oOaY","red":"RatingStars_red__1AhL8","yellow":"RatingStars_yellow__wUFXP"};